import React from 'react';
import { PageHeaderTemplate } from 'themes/layouts';

function PageHeader(props) {
    return <PageHeaderTemplate {...props} />;
}

export default PageHeader;
